module.exports = __webpack_public_path__ + "static/media/menu.f74428a9.svg";